import { render, staticRenderFns } from "./UnitsByGroup.vue?vue&type=template&id=8736ee72&"
import script from "./UnitsByGroup.vue?vue&type=script&lang=js&"
export * from "./UnitsByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports